

































































































import { Component, Vue } from 'vue-property-decorator';
import { PropertiesResponse, SystemResponse } from '@service/solr/admin/info';
import Gauge from '@components/dashboard/Gauge.vue';

@Component({
  components: { Gauge },
})
export default class Dashboard extends Vue {
  private loadingSystemInfo = false;
  private activeNames = ['instance', 'versions', 'jvm', 'system'];
  private response: SystemResponse = {
    lucene: {},
  } as SystemResponse;
  private propsResponse: PropertiesResponse = {
    'system.properties': {},
  } as PropertiesResponse;

  created() {
    this.loadingSystemInfo = true;
    this.$service.solr.admin.info
      .system()
      .then((res) => (this.response = res.data))
      .catch((err) => this.$notify.error(err.message))
      .finally(() => (this.loadingSystemInfo = false));
    this.$service.solr.admin.info
      .properties()
      .then((res) => (this.propsResponse = res.data))
      .catch((err) => this.$notify.error(err.message));
  }

  private get system() {
    return this.response.system || {};
  }

  private get jvm() {
    return (
      this.response.jvm || {
        memory: {
          raw: {},
        },
        jmx: {
          upTimeMS: 0,
        },
      }
    );
  }

  private get startTime() {
    const upTimeInSeconds = this.jvm.jmx.upTimeMS / 1000;
    if (upTimeInSeconds < 60) {
      return this.$i18n.t('common.justNow');
    }
    if (upTimeInSeconds < 60 * 60) {
      return this.$i18n.t('common.nMinutesAgo', [Math.ceil(upTimeInSeconds / 60)]);
    }
    if (upTimeInSeconds < 60 * 60 * 24) {
      return this.$i18n.t('common.nHoursAgo', [Math.ceil(upTimeInSeconds / 60 / 60)]);
    }
    return this.$i18n.t('common.nDaysAgo', [Math.ceil(upTimeInSeconds / 60 / 60 / 24)]);
  }

  private get physicalMemoryPercentage() {
    const free = this.system.freePhysicalMemorySize || 0;
    const total = this.system.totalPhysicalMemorySize || 1;
    return Math.round(((total - free) / total) * 10000) / 100;
  }

  private get swapSpacePercentage() {
    const free = this.system.freeSwapSpaceSize || 0;
    const total = this.system.totalSwapSpaceSize || 1;
    return Math.round(((total - free) / total) * 10000) / 100;
  }

  private get fileDescriptorPercentage() {
    const used = this.system.openFileDescriptorCount || 0;
    const total = this.system.maxFileDescriptorCount || 1;
    return Math.round((used / total) * 10000) / 100;
  }

  private get jvmMemoryPercentage() {
    const used = this.jvm.memory.raw.used || 0;
    const total = this.jvm.memory.raw.total || 1;
    return Math.round((used / total) * 10000) / 100;
  }
}
